import { AxiosInstance } from 'axios';
import {
  IFetchReleaseNotesParams,
  TFetchReleaseNotesResponse,
  TFetchReleaseNoteResponse,
} from '@sv-support-sdk/shared-types/src/api/releaseNotes';

export default (api: AxiosInstance) => ({
  getReleaseNotes: (params: IFetchReleaseNotesParams): Promise<TFetchReleaseNotesResponse> =>
    api.get('admin/release-note', { params }),
  getReleaseNote: (slug: string): Promise<TFetchReleaseNoteResponse> =>
    api.get(`admin/release-note/${slug}`),
});
